<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Analisis</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('analisis.create')"
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_analysis"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>

        <v-col cols="5" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('analisis.import')"
            dark
            color="green"
            class="float-right"
            @click="handleImport"
          >
            Importar
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('analisis.export')"
            dark
            color="success"
            width="140"
            class="float-right"
            style="margin-right: 10px;"
            :loading="is_download"
            @click="handleDownloadReport"
          >
            Descargar XLS
          </v-btn>
        </v-col>

        <!-- <v-col cols="2" class="pt-1">
          
        </v-col> -->

        <!-- <v-col cols="4">
          <v-btn
            dark
            class="float-right ml-2"
            color="green"
            @click="handleViewDownload"
          >
            Importar
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('analisis.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col> -->

        <!-- <v-col cols="2" class="pt-1">
                    <v-btn v-if="this.$hasPermision('analisis.filters')" dark color="#023145" outlined width="140" class="float-right" @click="handleShowFilters">
                        <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
                        Ver Filtros
                    </v-btn>
                </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="analisisArray"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todas los Analisis
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.name="{ item }">
                <span class="font-weight-medium">{{ item.name }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
              </template>
              <template v-slot:item.iscompound="{ item }">
                <span v-if="item.iscompound == 'on '" class="activo"> ON </span>
                <span
                  v-else
                  class=""
                  style="color:#F44336; display:flex; margin-left:50px"
                >
                  -
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="this.$hasPermision('analisis.edit')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <v-btn
              v-if="
                show_btn_active && this.$hasPermision('analisis.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="
                !show_btn_active && this.$hasPermision('analisis.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('analisis.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>
    <upload-analysis-service
      ref="uploadAnalysisService"
    ></upload-analysis-service>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/analysis-service/CreateUpdate";
import Filters from "../../../components/brands/Filters";
import UploadAnalysisService from "../../../components/analysis-service/UploadAnalysisService";

export default {
  name: "Analysis",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
    UploadAnalysisService,
  },
  data() {
    return {
      search_analysis: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Registros",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "CODIGO", value: "code" },
        { text: "NOMBRE DE ANALISIS", value: "name" },
        { text: "PRECIO", value: "base_price" },
        { text: "COMPUESTO", value: "iscompound" },
        { text: "TIEMPO ENTREGA", value: "tiempo_entrega" },
        { text: "CONDICIONES PREANALITICA", value: "preanalitica" },
        // { text: 'PRECIO COMPRA', value: 'cost' },
        // { text: 'CANTIDAD PRUEBAS', value: 'cant_pruebas' },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
      is_download: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        let filter = {
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        };
        if (this.search_analysis)
          filter = { ...filter, name: this.search_analysis };

        this.getAnalysis(filter)
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("analysis", ["analisisArray", "paginated", "file_sales"]),
    ...mapState("authentication", ["office_id"]),
  },
  methods: {
    ...mapActions("analysis", [
      "getAnalysis",
      "change_status",
      "delete",
      "newAnalysis",
      "analysisExcel",
    ]),
    ...mapActions("categories", ["getCategories"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo Analisis", "create");
    },
    handleEdit() {
      let analysis = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de analisis",
        "update",
        analysis
      );
    },
    handleShowFilters() {
      // console.log("entreeee");
      this.$refs.filters.showForm("Filtrar datos de marcas");
    },
    async getAllService() {
      await this.getAnalysis();
      this.parseDataAnalysis();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        name: this.search_analysis,
      };
      await this.getAnalysis(filters);
      this.parseDataAnalysis();
    },
    async handleChangeStatus() {
      let service = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(service);
    },
    async handleDelete() {
      let service = this.selectedRows[0];
      await this.delete(service);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    parseDataAnalysis() {
      let newAnalys = [];
      this.analisisArray.map((analysis) => {
        const analysisAux = { ...analysis };
        if (analysisAux.service_product.length > 0) {
          let bandService_product = false;
          const newArraySErvice_product = [];
          analysisAux.service_product.map((sp) => {
            if (sp.office_id == null || sp.office_id == this.office_id) {
              // ! validar en backend el filtrado por office del detalle de los reactivos
              newArraySErvice_product.push({ ...sp });
            }
          });
          analysisAux.service_product = newArraySErvice_product;
        }
        // if(analysis.service_product.length > 0){
        //   this.service_product = this.service_product?.map(sp => {
        //     // if(sp.office_id)
        //     console.log(sp)
        //   })
        // }
        newAnalys.push(analysisAux);
      });
      this.newAnalysis(newAnalys);
    },
    async handleImport() {
      this.$refs.uploadAnalysisService.show();
    },
    async getAllCategories() {
      await this.getCategories();
    },
    async handleDownloadReport() {
      this.is_download = true;
      // this.emptyFileSales();
      let filters_data = Object.assign({}, this.filters);
      filters_data.company_id = this.company_id;
      await this.analysisExcel(filters_data);
      this.is_download = false;
      if (this.file_sales) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_sales;
        window.open(url);
      }
    },
  },
  created() {
    this.getAllService();
    this.getAllCategories();
  },
  destroyed() {
    // cancelRequest();
  },
};
</script>

<style scoped></style>
